export const FETCH_GABARITS = "FETCH_GABARITS";
export const FETCH_GABARITS_COMPLETED = "FETCH_GABARITS_COMPLETED";
export const FETCH_GABARITS_FAILED = "FETCH_GABARITS_FAILED";

export const SAVE_GABARIT = "SAVE_GABARIT";
export const SAVE_GABARIT_COMPLETED = "SAVE_GABARIT_COMPLETED";
export const SAVE_GABARIT_FAILED = "SAVE_GABARIT_FAILED";

export const RENAME_GABARIT = "RENAME_GABARIT";
export const RENAME_GABARIT_COMPLETED = "RENAME_GABARIT_COMPLETED";
export const RENAME_GABARIT_FAILED = "RENAME_GABARIT_FAILED";

export const DELETE_GABARIT = "DELETE_GABARIT";
export const DELETE_GABARIT_COMPLETED = "DELETE_GABARIT_COMPLETED";
export const DELETE_GABARIT_FAILED = "DELETE_GABARIT_FAILED";

export const FETCH_GABARIT = "FETCH_GABARIT";
export const FETCH_GABARIT_COMPLETED = "FETCH_GABARIT_COMPLETED";
export const FETCH_GABARIT_FAILED = "FETCH_GABARIT_FAILED";

export const LOAD_GABARIT = "LOAD_GABARIT";
export const SET_SELECTED_GABARIT = "SET_SELECTED_GABARIT";

/**
 * Charge la liste des gabarits depuis l'API
 */
export const fetchGabarits = () => ({
  type: FETCH_GABARITS,
  meta: {
    async: true,
    blocking: false,
    path: `/api/pro/gabarits.json`,
    method: "GET",
  },
});

/**
 * Sauvegarde un nouveau gabarit
 * @param {string} name - Nom du gabarit
 * @param {object} data - Données du formulaire commande (sans devis/facture)
 */
export const saveGabarit = (name, data) => ({
  type: SAVE_GABARIT,
  meta: {
    async: true,
    blocking: true,
    path: `/api/pro/gabarits.json`,
    method: "POST",
    body: { name, data },
  },
});

/**
 * Renomme un gabarit existant
 * @param {number} id - ID du gabarit
 * @param {string} name - Nouveau nom
 */
export const renameGabarit = (id, name) => ({
  type: RENAME_GABARIT,
  meta: {
    async: true,
    blocking: true,
    path: `/api/pro/gabarits/${id}.json`,
    method: "PUT",
    body: { name },
  },
});

/**
 * Supprime un gabarit
 * @param {number} id - ID du gabarit
 */
export const deleteGabarit = (id) => ({
  type: DELETE_GABARIT,
  meta: {
    async: true,
    blocking: true,
    path: `/api/pro/gabarits/${id}.json`,
    method: "DELETE",
  },
  payload: { id },
});

/**
 * Charge un gabarit individuel par ID (avec ses data complètes)
 * @param {number} id - ID du gabarit
 */
export const fetchGabarit = (id) => ({
  type: FETCH_GABARIT,
  meta: {
    async: true,
    blocking: true,
    path: `/api/pro/gabarits/${id}.json`,
    method: "GET",
  },
});

/**
 * Sélectionne un gabarit (met à jour le state local)
 */
export const setSelectedGabarit = (gabarit) => ({
  type: SET_SELECTED_GABARIT,
  payload: gabarit,
});
